import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserStatusConst } from 'src/app/Models/userStatus.const';
import { FloorService } from 'src/app/Services/Floor/floor.service';
import { UserService } from 'src/app/Services/User/user.service';
import { debounceTime } from 'rxjs/operators';
import { AlertInfo, AlertService, AlertType } from 'src/app/Services/Alert/alert.service';
import { CurrentUserService } from 'src/app/Services/CurrentUser/current-user.service';

@Component({
  standalone: false,
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  email: string;

  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userService.getMe().subscribe((data) => {
      this.email = data?.value?.emailAddress;

      if (data?.value?.userStatusId == UserStatusConst.Active) {
        this.router.navigateByUrl('/'); //If you want to edit the register page as a register user comment this line out
      }
    });
  }
}
